import { LOADER_STATUS ,FILE_DATA,SET_FREQUENCY} from "./constants";

export const initialState = {
    loaderStatus: false,  
    fileData: [],
    frequency:''
};
  
  /* eslint-disable default-case, no-param-reassign */
  const itc04FileReturnReducer = (state = initialState, action) =>{
      switch (action.type) {
        
        case LOADER_STATUS:
          return {
            ...state,
            loaderStatus:action.loaderStatus
          }
          case FILE_DATA:
            return {
              ...state,
              fileData:action.fileData
            }
          case SET_FREQUENCY:
            return {
              ...state,
              frequency:action.payload
            }
        default:
          return state;
      }
    };
  
  export default itc04FileReturnReducer;